<template>
  <TableCommon
    title="银行信息"
    :custome-config="() => vxeShowCustom('xTable3')"
  >
    <vxe-grid
      ref="xTable3"
      class="table-block"
      border
      :highlight-hover-row="true"
      resizable
      :show-overflow="true"
      max-height="500"
      align="center"
      size="mini"
      :empty-render="{name: 'NotData'}"
      :toolbar-config="{ custom: true, size: 'mini' }"
      :row-config="{ isCurrent: true }"
      :edit-config="canEdit ? { trigger: 'click', mode: 'cell' } : false"
      :columns="gridOptions.columns"
      :data="gridOptions.data"
    />
  </TableCommon>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    bank: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters(['role']),
    // 判断是否可以编辑
    canEdit() {
      return this.role.ROLE === 'WLYALL' || this.role.ROLE === 'WLY004'
    },
    // 可编辑的列（排除序号列）
    editableColumns() {
      return this.gridOptions.columns.filter(col => col.type !== 'seq')
    }
  },
  data() {
    return {
      id: '',
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      originalData: [], // 保存原始数据，用于对比变更
      gridOptions: {
        columns: [
          { type: 'seq', field: 'seq', title: '序号', width: 50 },
          { title: '账户类型', field: 'accountType', minWidth: 200 },
          { title: '银行名称', field: 'ZZFLD000022', minWidth: 200 },
          { title: '银行账号', field: 'ZZFLD000023', minWidth: 200 },
          { title: '协议编号', field: 'ZZFLD00009J', minWidth: 200 },
          { title: '联系人', field: 'ZZFLD00009L', minWidth: 200 },
          { title: '电话', field: 'ZZFLD00009M', minWidth: 200 },
          { title: '可开具发票类型', field: 'ZZFLD00009R', minWidth: 200 }
        ],
        data: []
      }
    }
  },
  watch: {
    bank: {
      handler(val) {
        const bankData = val || []
        this.gridOptions.data = bankData
        // 只在初始化时保存原始数据，避免后续更新覆盖
        if (this.originalData.length === 0 && bankData.length > 0) {
          this.originalData = JSON.parse(JSON.stringify(bankData))
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    const bankData = this.bank || []
    this.gridOptions.data = bankData
    // 保存原始数据的深拷贝，用于对比变更
    this.originalData = JSON.parse(JSON.stringify(bankData))
    // 根据权限设置列的编辑配置
    this.setColumnsEditConfig()
  },
  methods: {
    // 设置列的编辑配置
    setColumnsEditConfig() {
      if (this.canEdit) {
        this.gridOptions.columns.forEach(col => {
          if (col.type !== 'seq') {
            col.editRender = { name: 'input' }
          }
        })
      }
    },
    // 对比两个对象是否相等（忽略 _X_ID 等内部字段）
    isDataEqual(obj1, obj2) {
      const keys1 = Object.keys(obj1).filter(k => !k.startsWith('_'))
      const keys2 = Object.keys(obj2).filter(k => !k.startsWith('_'))
      
      if (keys1.length !== keys2.length) return false
      
      for (const key of keys1) {
        if (String(obj1[key]) !== String(obj2[key])) {
          return false
        }
      }
      return true
    },
    // 提交表单，返回修改后的银行数据和变更项
    submitForm() {
      const currentData = this.gridOptions.data || []
      const changes = []
      
      // 找出变更的项（对比原始数据和当前数据）
      currentData.forEach((current) => {
        // 如果有 GUID 或 id，说明是已存在的记录，需要找到对应的原始记录
        let original = null
        if (current.GUID) {
          original = this.originalData.find(item => item.GUID === current.GUID)
        } else if (current.id) {
          original = this.originalData.find(item => item.id === current.id)
        } else {
          // 如果没有唯一标识，按索引匹配（仅当数量相同时）
          const index = currentData.indexOf(current)
          if (index < this.originalData.length) {
            original = this.originalData[index]
          }
        }
        
        // 如果找到了原始记录且数据有变更
        if (original && !this.isDataEqual(original, current)) {
          // 找出具体变更的字段
          const changedFields = {}
          const editableFields = ['accountType', 'ZZFLD000022', 'ZZFLD000023', 'ZZFLD00009J', 'ZZFLD00009L', 'ZZFLD00009M', 'ZZFLD00009R']
          
          editableFields.forEach(field => {
            const oldValue = String(original[field] || '')
            const newValue = String(current[field] || '')
            if (oldValue !== newValue) {
              changedFields[field] = {
                old: original[field],
                new: current[field]
              }
            }
          })
          
          if (Object.keys(changedFields).length > 0) {
            changes.push({
              ...current,
              _changed: true,
              _changedFields: changedFields
            })
          }
        }
      })
      
      // 始终返回对象格式，包含 data 和 changes
      // data 是当前所有银行数据（数组格式），changes 是变更项数组
      return {
        data: currentData,
        changes: changes
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/client-manage/components/BankInfo.vue